import { Inputfiledsbase } from './models/inputfiledsbase';

export class RadioQuestion extends Inputfiledsbase<string> {
  override controlType = 'radio';
}